module.exports = __webpack_public_path__ + "media/javascripts/apps/roku/assets/images/TVslide-4-3d8c167f92a8dedf06afe32562f1f1a9.png";